import http from '@/communication/AuthConnection'

/**
* Read the file dropped
*/
const readFile = ({ lab, maturityDate, fisicalForm }, pFile) => {
  const formData = new FormData()
  formData.append('lab', lab)
  formData.append('maturityDate', maturityDate)
  formData.append('fisicalForm', JSON.stringify(fisicalForm))
  formData.append('file', pFile)
  return http
    .post('/v1/cbpf/document', formData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    })
}

export default readFile



// WEBPACK FOOTER //
// ./src/view/record/cbpf/components/form-file-input/FileHandle.js